<template>
    <v-card width="100%" flat>
        <v-card-title>
            <div class="headline">
                Sady vstupenek
            </div>
            <v-spacer></v-spacer>

            <v-combobox
                    clearable
                    single-line
                    hide-details
                    class="pt-0"
                    label="Filtrovat podle události"
                    :items="eventList"
                    item-value="id"
                    item-text="name"
                    v-model="selectedEvent"
            ></v-combobox>

            <v-spacer></v-spacer>

            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Vyhledávání"
                    single-line
                    class="pt-0"
                    hide-details
            ></v-text-field>
        </v-card-title>

        <v-data-table
                v-model="selected"
                :headers="headers"
                :items="filteredItems"
                :search="search"
                class="elevation-2"
                dense
                show-expand
                :footer-props="{
                    'items-per-page-options': [10, 20, 50, 100]
                }"
                @pagination="page"
        >
            <template v-slot:item.validate="{ item }">
                <v-icon v-if="item.validate" small color="green">check_circle</v-icon>
                <v-icon v-if="!item.validate" small color="red">remove_circle</v-icon>
            </template>

            <template v-slot:item.action="{ item }">
                <EditDeleteActions :hideDelete="true"
                        @edit="editItem(item)"
                />
            </template>

            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <h3 class="mx-4 mt-4">Cenové hladiny</h3>
                    <v-simple-table class="my-5">
                        <thead style="border-bottom: 1px solid #eee">
                            <th class="px-4 text-left">Jméno</th>
                            <th class="px-4 text-left">Text na vstupenkách</th>
                            <th class="px-4 text-center">Počet osob</th>
                            <th class="px-4 text-right">Cena</th>
                            <th class="px-4 text-center">Měna</th>
                        </thead>
                        <tbody>
                            <tr
                                v-for="row in item.prices"
                                :key="row.id"
                            >
                                <td>{{ row.name }}</td>
                                <td>{{ row.title }}</td>
                                <td class="text-center">{{ row.people }}</td>
                                <td class="text-right">{{ row.price }}</td>
                                <td class="text-center">{{ row.currency }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </td>
            </template>
        </v-data-table>

        <TicketsetDialog ref="dialog" @complete="onComplete" />

        <DeleteConfirm :show="deleteConfirm"
                       @confirm="doDeleteConfirm"
                       @cancel="deleteConfirm=false"
        />
    </v-card>
</template>

<script>
    import BaseListMixin from '../mixins/BaseListMixin'
    import TicketsetDialog from '../components/dialogs/TicketsetDialog'

    export default {
        mixins: [BaseListMixin],

        components: {
            TicketsetDialog
        },

        data () {
            return {
                module: 'ticketset',
                headers: [
                    { text: 'Jméno', value: 'name' },
                    // { text: 'Hláška při kontrole', value: 'customName', width: '200px'},
                    { text: 'Událost', value: 'event.name' },
                    { text: 'Vstupů', value: 'entries', width: '100px', align:'center' },
                    { text: 'Minut mezi vstupy', value: 'entryPause', width: '150px', align:'center' },
                    // { text: 'Prefix', value: 'prefix', width:'100px' },
                    { text: 'Hláška', value: 'validate', width: '100px', align:'center' },
                    { text: 'Vstupenek', value: 'ticketCount', width: '120px', align:'right' },
                    { text: 'Ověřeno', value: 'validatedCount', width: '120px', align:'right'},
                    { text: '', value: 'action', sortable: false},
                ],
                selectedEvent: null
            }
        },

        mounted () {
            this.$store.dispatch('event/list')
            this.$store.dispatch('ticketset/list')
        },

        computed: {
            eventList () {
                return this.$store.state.event.list
            },

            filteredItems () {
                return this.$store.state.ticketset.list.reduce((acc, block) => {
                    if (this.selectedEvent) {
                        if (this.selectedEvent.id === block.event.id) {
                            return [...acc, block]
                        } else {
                            return acc
                        }
                    } else {
                        return [...acc, block]
                    }
                }, [])
            }
        },

        methods: {
            page (event) {
                if (event.pageCount > 0) {
                    const ids = this.filteredItems.slice(event.pageStart, event.pageStop).map(item => parseInt(item.id))
                    this.$store.dispatch('ticketset/listFull', ids)
                }
            },
        }
    }
</script>
